// The error name the API sends, under either envelope it has used.
// Kept free of imports so UI copy modules can use it without the API client.
export function apiErrorName(body) {
  return body?.error?.name ?? body?.name ?? null;
}
